
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"6","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 14.805c.953-.677 1.43-1.357 1.43-2.04 0-.275-.068-.476-.203-.6-.136-.126-.412-.23-.829-.313-1.135-.214-1.94-.547-2.414-1-.468-.459-.703-1.07-.703-1.836 0-1.427.823-2.368 2.469-2.82v-.094C1.49 5.768.86 5.122.86 4.164c0-.984.718-1.648 2.156-1.992v-.14h-.72c-.728 0-1.236-.09-1.523-.266C.487 1.589.336 1.263.32.789h1.375c.042.438.425.656 1.149.656h2.851v.617l-.36.024c-.968.062-1.723.27-2.265.625-.541.349-.812.82-.812 1.414 0 .536.161.932.484 1.188.323.255.899.382 1.727.382h.68v.75h-.493c-.932 0-1.656.211-2.172.633-.51.422-.765 1.005-.765 1.75 0 .526.127.945.383 1.258.26.312.786.555 1.578.726.786.167 1.323.355 1.61.563.29.208.437.555.437 1.04 0 .551-.201 1.059-.602 1.523-.401.468-.956.942-1.664 1.421L3 14.805z","fill":"currentColor"}})])
          )
        }
      }
    